import anime from 'animejs';
import {uuid} from './uuid';
import {BREAKPOINT_LG, BREAKPOINT_SM} from '../globals';

let inView = require('in-view');

export default function InitAnimations() {
	const reducedMotionMatch = window.matchMedia('(prefers-reduced-motion: reduce)');

	if (reducedMotionMatch && !reducedMotionMatch.matches) {
		const onepageTimeline = anime.timeline();

		InitHeroTextAnimation(onepageTimeline);
		InitFormAnimations(onepageTimeline);
		InitSpecialHeadingAnimation();
		InitBigImageAnimations();
		InitBardSetAnimation();
		InitCardAnimations();
	}
}

function InitHeroTextAnimation(timeline) {
	if (window.innerWidth < BREAKPOINT_LG) return;

	const heroHeading = document.querySelector('header.hero .hero-content h1');
	const heroContent = document.querySelectorAll('header.hero h1 ~ *, header.hero .bard__module.button');
	if (window.innerWidth < BREAKPOINT_SM || heroHeading === null || heroContent.length === 0) return;

	timeline ??= anime.timeline();

	heroHeading.innerHTML = heroHeading.textContent.replace(/\S/g, '<span class="letter">$&</span>');

	timeline
			.add({
				targets: heroHeading.querySelectorAll('.letter'),
				translateX: [-40, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: 'easeOutExpo',
				duration: 300,
				delay: (el, i) => 300 + 30 * i
			})
			.add({
				targets: heroContent,
				opacity: [0, 1],
				easing: 'easeInSine',
				duration: 300,
				delay: (el, i) => 300 + 30 * i
			});
}

function InitSpecialHeadingAnimation() {
	const specialHeadings = document.querySelectorAll('.bard__module.special_heading');
	if (specialHeadings.length === 0) return;

	specialHeadings.forEach((specialHeading) => {
		specialHeading.dataset.heading = uuid();

		inView(`.bard__module.special_heading[data-heading="${specialHeading.dataset.heading}"]`).once('enter', () => {
			anime({
				targets: specialHeading,
				translateX: [-50, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: 'easeOutSine',
				duration: 600
			});
		});
	});
}

function InitBardSetAnimation() {
	const animatedBardSets = document.querySelectorAll('.bard__module.accordion, .bard__module.design_element,' +
			' .bard__module.image_with_text, .bard__module.wide_image, .bard__module.button_container,' +
			' .bard__module.download_kit, .bard__module.alexander, .bard__module.emma,' +
			' .bard__module.ivan, .bard__module.team_members, .bard__module.section_paragraph,' +
			' .bard__module.video, .bard:not(.sub-bard) > .bard__module.text');
	if (animatedBardSets.length === 0) return;

	animatedBardSets.forEach((animatedBardSet) => {
		animatedBardSet.dataset.animatedBard = uuid();
		animatedBardSet.style.visibility = 'hidden';

		inView(`[data-animated-bard="${animatedBardSet.dataset.animatedBard}"]`).once('enter', () => {
			anime({
				targets: animatedBardSet,
				opacity: [0, 1],
				easing: 'easeInSine',
				duration: 500,
				delay: 200
			});


			animatedBardSet.style.visibility = 'visible';
		});
	});
}

function InitCardAnimations() {
	const cardContainers = document.querySelectorAll('.card-container');
	if (cardContainers.length === 0) return;

	cardContainers.forEach((cardContainer) => {
		cardContainer.dataset.cards = uuid();

		inView(`.card-container[data-cards="${cardContainer.dataset.cards}"]`).once('enter', () => {
			anime({
				targets: cardContainer.querySelectorAll('.card'),
				opacity: [0, 1],
				translateY: [40, 0],
				easing: 'easeInSine',
				duration: 500,
				delay: (el, i) => 150 * i
			});
		});
	});
}

function InitFormAnimations(timeline) {
	const inputFields = document.querySelectorAll('.contact-container');
	if (inputFields.length === 0) return;

	timeline ??= anime.timeline();

	inputFields.forEach((inputField) => {
		inputField.style.opacity = 0;

		timeline
				.add({
					targets: inputField,
					opacity: [0, 1],
					easing: 'easeInSine',
					duration: 150,
				});
	});
}

function InitBigImageAnimations() {
	const animatedImages = document.querySelectorAll('.bard__module.emma img');
	if (animatedImages.length === 0) return;

	animatedImages.forEach((animatedImage) => {
		animatedImage.dataset.animatedImage = uuid();
		animatedImage.style.visibility = 'hidden';

		inView(`[data-animated-image="${animatedImage.dataset.animatedImage}"]`).once('enter', () => {
			anime({
				targets: animatedImage,
				scaleX: [.7, 1],
				easing: 'easeInOutCirc',
				duration: 1000,
				delay: 200
			});

			anime({
				targets: animatedImage,
				opacity: [0, 1],
				easing: 'easeInCirc',
				duration: 1000,
				delay: 200
			});

			animatedImage.style.visibility = 'visible';
		});
	});
}
